// 智慧财务
import Log from '../view/log'
import FinanceOverView from '../view/Finance/FinanceOverView/FinanceOverView'
import rentFinance from '../view/Finance/InvestmentFinance/rentFinance'
import rentFinanceModify from '../view/Finance/InvestmentFinance/rentFinanceModify'
import propertyFinance from '../view/Finance/InvestmentFinance/propertyFinance'
import propertyFinanceModify from '../view/Finance/InvestmentFinance/propertyFinanceModify'
import depositFinance from '../view/Finance/InvestmentFinance/depositFinance'
import depositFinanceModify from '../view/Finance/InvestmentFinance/depositFinanceModify'
import contractPayRecord from '../view/Finance/InvestmentFinance/contractPayRecord'
import addContractPayRecord from '../view/Finance/InvestmentFinance/addContractPayRecord'
import contractPayRecordCurrent from '../view/Finance/InvestmentFinance/contractPayRecordCurrent'
import recordRelatedBills from '../view/Finance/InvestmentFinance/recordRelatedBills'
import ElectricityFinanceBill from '../view/Finance/ElectronicFinance/ElectricityFinanceBill'
import ElectronicFinancePayRecord from '../view/Finance/ElectronicFinance/ElectronicFinancePayRecord'
import ElectronicFinanceRentMoney from '../view/Finance/ElectronicFinance/ElectronicFinanceRentMoney'
import ElectronicFinanceSettlementRecord from '../view/Finance/ElectronicFinance/ElectronicFinanceSettlementRecord'
import WaterFinanceBill from '../view/Finance/WaterFinance/WaterFinanceBill'
import WaterFinancePayRecord from '../view/Finance/WaterFinance/WaterFinancePayRecord'
import WaterFinanceRentMoney from '../view/Finance/WaterFinance/WaterFinanceRentMoney'
import WaterFinanceSettlementRecord from '../view/Finance/WaterFinance/WaterFinanceSettlementRecord'
import SteamFinanceBill from '../view/Finance/SteamFinance/SteamFinanceBill'
import SteamFinancePayRecord from '../view/Finance/SteamFinance/SteamFinancePayRecord'
import SteamFinanceRentMoney from '../view/Finance/SteamFinance/SteamFinanceRentMoney'
import SteamFinanceSettlementRecord from '../view/Finance/SteamFinance/SteamFinanceSettlementRecord'
import GasFinanceBill from '../view/Finance/GasFinance/GasFinanceBill'
import GasFinancePayRecord from '../view/Finance/GasFinance/GasFinancePayRecord'
import GasFinanceRentMoney from '../view/Finance/GasFinance/GasFinanceRentMoney'
import GasFinanceSettlementRecord from '../view/Finance/GasFinance/GasFinanceSettlementRecord'
import ParkingFinanceMonthlyPayment from '../view/Finance/ParkingFinance/ParkingFinanceMonthlyPayment'
import ParkingFinanceTemporaryStop from '../view/Finance/ParkingFinance/ParkingFinanceTemporaryStop'
import placeBookingFinancePayRecord from '../view/Finance/placeBookingFinance/placeBookingFinancePayRecord'
import repairFinancePayRecord from '../view/Finance/repairFinance/repairFinancePayRecord'
import otherBill from '../view/Finance/OtherBill/otherBill'
import OtherRentFinance from '../view/Finance/OtherContracts/OtherRentFinance'
import OtherRentFinanceModify from '../view/Finance/OtherContracts/OtherRentFinanceModify'
import financeRefund from '../view/Finance/FinanceRefund/financeRefund'
import addFinanceRefund from '../view/Finance/FinanceRefund/addFinanceRefund'
import refundBillManagement from '../view/Finance/refundBillManagement/refundBillManagement'
import tenantBill from '../view/Finance/tenantBill/tenantBill'
import tenantList from '../view/Finance/tenantBill/tenantList'
import FinanceNav from '../view/Finance/FinanceNav'
import WorkAttendanceNav from "../view/WorkAttendance/WorkAttendanceNav";

export default [
  /* 智慧财务 */
  {
    path: '/finance_over_view',
    name: 'finance-over-view',
    components: {
      default: FinanceNav,
      a: FinanceOverView
    }
  },
  {
    path: '/rent_finance',
    name: 'rent-finance',
    components: {
      default: FinanceNav,
      a: rentFinance
    },
    meta: {
      keepAlive: true
    }
  },
  {
    path: '/rent_finance_modify/:id',
    name: 'rent-finance-modify',
    components: {
      default: FinanceNav,
      a: rentFinanceModify
    }
  },
  {
    path: '/property_finance',
    name: 'property-finance',
    components: {
      default: FinanceNav,
      a: propertyFinance
    },
    meta: {
      keepAlive: true
    }
  },
  {
    path: '/property_finance_modify/:id',
    name: 'property-finance-modify',
    components: {
      default: FinanceNav,
      a: propertyFinanceModify
    }
  },
  {
    path: '/deposit_finance',
    name: 'deposit-finance',
    components: {
      default: FinanceNav,
      a: depositFinance
    },
    meta: {
      keepAlive: true
    }
  },
  {
    path: '/deposit_finance_modify/:id',
    name: 'deposit-finance-modify',
    components: {
      default: FinanceNav,
      a: depositFinanceModify
    }
  },
  {
    path: '/contract_pay_record',
    name: 'contract-pay-record',
    components: {
      default: FinanceNav,
      a: contractPayRecord
    },
    meta: {
      keepAlive: true
    }
  },
  {
    path: '/add_contract_pay_record',
    name: 'add-contract-pay-record',
    components: {
      default: FinanceNav,
      a: addContractPayRecord
    }
  },
  {
    path: '/add_contract_pay_record_current/:id',
    name: 'add-contract-pay-record-current',
    components: {
      default: FinanceNav,
      a: contractPayRecordCurrent
    }
  },
  {
    path: '/record_related_bills/:id',
    name: 'record-related-bills',
    components: {
      default: FinanceNav,
      a: recordRelatedBills
    }
  },
  {
    path: '/electronic_finance_bill',
    name: 'electronic-finance-bill',
    components: {
      default: FinanceNav,
      a: ElectricityFinanceBill
    },
    meta: {
      keepAlive: true
    }
  },
  {
    path: '/electronic_finance_pay_record',
    name: 'electronic-finance-pay-record',
    components: {
      default: FinanceNav,
      a: ElectronicFinancePayRecord
    },
    meta: {
      keepAlive: true
    }
  },
  {
    path: '/electronic_finance_rent_record',
    name: 'electronic-finance-rent-record',
    components: {
      default: FinanceNav,
      a: ElectronicFinanceRentMoney
    },
    meta: {
      keepAlive: true
    }
  },
  {
    path: '/electronic_finance_settlement_record',
    name: 'electronic-finance-settlement-record',
    components: {
      default: FinanceNav,
      a: ElectronicFinanceSettlementRecord
    },
    meta: {
      keepAlive: true
    }
  },
  {
    path: '/water_finance_bill',
    name: 'water-finance-bill',
    components: {
      default: FinanceNav,
      a: WaterFinanceBill
    },
    meta: {
      keepAlive: true
    }
  },
  {
    path: '/water_finance_pay_record',
    name: 'water-finance-pay-record',
    components: {
      default: FinanceNav,
      a: WaterFinancePayRecord
    },
    meta: {
      keepAlive: true
    }
  },
  {
    path: '/water_finance_rent_record',
    name: 'water-finance-rent-record',
    components: {
      default: FinanceNav,
      a: WaterFinanceRentMoney
    },
    meta: {
      keepAlive: true
    }
  },
  {
    path: '/water_finance_settlement_record',
    name: 'water-finance-settlement-record',
    components: {
      default: FinanceNav,
      a: WaterFinanceSettlementRecord
    },
    meta: {
      keepAlive: true
    }
  },
  {
    path: '/steam_finance_bill',
    name: 'steam-finance-bill',
    components: {
      default: FinanceNav,
      a: SteamFinanceBill
    },
    meta: {
      keepAlive: true
    }
  },
  {
    path: '/steam_finance_pay_record',
    name: 'steam-finance-pay-record',
    components: {
      default: FinanceNav,
      a: SteamFinancePayRecord
    },
    meta: {
      keepAlive: true
    }
  },
  {
    path: '/steam_finance_rent_record',
    name: 'steam-finance-rent-record',
    components: {
      default: FinanceNav,
      a: SteamFinanceRentMoney
    },
    meta: {
      keepAlive: true
    }
  },
  {
    path: '/steam_finance_settlement_record',
    name: 'steam-finance-settlement-record',
    components: {
      default: FinanceNav,
      a: SteamFinanceSettlementRecord
    },
    meta: {
      keepAlive: true
    }
  },
  {
    path: '/gas_finance_bill',
    name: 'gas-finance-bill',
    components: {
      default: FinanceNav,
      a: GasFinanceBill
    },
    meta: {
      keepAlive: true
    }
  },
  {
    path: '/gas_finance_pay_record',
    name: 'gas-finance-pay-record',
    components: {
      default: FinanceNav,
      a: GasFinancePayRecord
    },
    meta: {
      keepAlive: true
    }
  },
  {
    path: '/gas_finance_rent_record',
    name: 'gas-finance-rent-record',
    components: {
      default: FinanceNav,
      a: GasFinanceRentMoney
    },
    meta: {
      keepAlive: true
    }
  },
  {
    path: '/gas_finance_settlement_record',
    name: 'gas-finance-settlement-record',
    components: {
      default: FinanceNav,
      a: GasFinanceSettlementRecord
    },
    meta: {
      keepAlive: true
    }
  },
  {
    path: '/parking_finance_monthly_payment',
    name: 'parking-finance-monthly-payment',
    components: {
      default: FinanceNav,
      a: ParkingFinanceMonthlyPayment
    },
    meta: {
      keepAlive: true
    }
  },
  {
    path: '/parking_finance_temporary_stop',
    name: 'parking-finance-temporary-stop',
    components: {
      default: FinanceNav,
      a: ParkingFinanceTemporaryStop
    },
    meta: {
      keepAlive: true
    }
  },
  {
    path: '/place_booking_finance_pay_record',
    name: 'place-booking-finance-pay-record',
    components: {
      default: FinanceNav,
      a: placeBookingFinancePayRecord
    },
    meta: {
      keepAlive: true
    }
  },
  {
    path: '/repair_finance_pay_record',
    name: 'repair-finance-pay-record',
    components: {
      default: FinanceNav,
      a: repairFinancePayRecord
    },
    meta: {
      keepAlive: true
    }
  },
  {
    path: '/other_bill',
    name: 'other-bill',
    components: {
      default: FinanceNav,
      a: otherBill
    },
    meta: {
      keepAlive: true
    }
  },
  {
    path: '/other_rent_finance',
    name: 'other-rent-finance',
    components: {
      default: FinanceNav,
      a: OtherRentFinance
    },
    meta: {
      keepAlive: true
    }
  },
  {
    path: '/other_rent_finance_modify/:id',
    name: 'other-rent-finance-modify',
    components: {
      default: FinanceNav,
      a: OtherRentFinanceModify
    }
  },
  {
    path: '/finance_refund',
    name: 'finance-refund',
    components: {
      default: FinanceNav,
      a: financeRefund
    },
    meta: {
      keepAlive: true
    }
  },
  {
    path: '/add_finance_refund',
    name: 'add-finance-refund',
    components: {
      default: FinanceNav,
      a: addFinanceRefund
    }
  },
  {
    path: '/refund_bill_management',
    name: 'refund-bill-management',
    components: {
      default: FinanceNav,
      a: refundBillManagement
    }
  },
  {
    path: '/tenant_bill',
    name: 'tenant-bill',
    components: {
      default: FinanceNav,
      a: tenantBill
    }
  },
  {
    path: '/tenant_list',
    name: 'tenant-list',
    components: {
      default: FinanceNav,
      a: tenantList
    }
  },
  /* 智慧财务 */

  // 财务操作日志
  {
    path: '/finance_log',
    name: 'finance-log',
    components: {
      default: FinanceNav,
      a: Log
    }
  }
]



// WEBPACK FOOTER //
// ./src/router/Finance.js